// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .content-wrap {
    height: auto;
  }
  .Modal_Heading {
    border-bottom: none;
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    font-size: ${(props) => props.theme.typography.fontSizes.fs22};
    display: flex;
    justify-content: center;
    height: auto;
    margin-bottom: 0px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
      justify-content: center;
      height: auto;
    }
  }
  .Modal-Header {
    z-index: ${(props) => props.theme.zindex.zIndexQuickView};
  }
  .promotion-message-text {
    margin-bottom: 16px;
    color: ${(props) => {
      switch (props?.theme?.brand) {
        case 'gym':
          return props.theme.colorPalette.orange[900];
        case 'snj':
          return '#56318A';
        default:
          return props.theme.colorPalette.blue[200];
      }
    }};
  }
  .product-image-container {
    margin: 0 auto 16px;
    height: auto !important;
  }
  .pointer {
    cursor: pointer;
  }
  .eligible-items-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-left: -8px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      flex-wrap: nowrap;
      overflow-y: auto;
      justify-content: flex-start;
    }
  }
  .list-price {
    text-decoration: line-through;
  }
  .eligible-item {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    flex: 45%;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    max-width: 200px;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    box-sizing: border-box;
    height: auto;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      min-width: 146px;
      max-width: 146px;
    }
  }
  .custom-ranking-container {
    position: relative;
  }
  .eligible-items-heading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
  .offer-detail-tile {
    background: #fff;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG}
      ${(props) => props.theme.spacing.ELEM_SPACING.REG};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.REG};
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      border-top: none;
    }
  }
  .promotion-message-validity {
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    }
  }
  .eligible-products {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0;
      border-radius: 0;
    }
  }
  .view-all-products-wrapper {
    bottom: -4px;
    position: sticky;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.22) 0px 0px 6px 0px;
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    padding: 16px 22px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      border-top: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    }
    .view_all_anchor {
      border: 1px solid #9b9b9b;
      width: 100%;
      text-align: center;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      margin: 0 auto;
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
      color: ${(props) => props.theme.colorPalette.gray[800]};
    }
  }
  .terms-and-conditions-wrapper {
    background: #fff;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0;
      border-radius: 0;
    }
  }
  .tnc-heading-text {
    margin-bottom: 12px;
  }
  .ratings-container {
    margin-top: 2px;
  }
  .details-wrapper {
    padding: 16px 16px 24px 16px;
  }
  .icon-header-wrapper {
    display: flex;
  }
  .icon-container {
    margin-right: 12px;
    margin-top: 8px;
  }
  .icon {
    max-width: fit-content;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 25px;
    }
  }
  ${(props) =>
    props.fromCartOffers
      ? `.offer-detail-tile {
          padding: 24px;
          border-radius: 6px;
          border: 1px solid ${props.theme.colors.PRIMARY.LIGHTERGRAY};
          background: #FFF;
          margin: 24px;
        }
        .promotion-message-text {
          color: ${props.theme.colorPalette.gray[900]};
          font-family: Nunito;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;
        }
        .promotion-message-validity {
          color: ${props.theme.colorPalette.gray[900]};
          font-family: Nunito;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
        .details-wrapper {
          margin: 24px;
          padding:0;
        }
        .terms-and-conditions-wrapper{
          padding:0;
          margin: 24px;
        }
        .offer-icon {
          width: 16px;
          height: 16px;
        }
        .icon-container {
          margin-top:0;
        }
        `
      : ''}
`;

export const modalStyles = css`
  div.TCPModal__InnerContent.offer-details-innerContent {
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    background: #f4f4f4;
    padding: 0;
    width: 481px;
    overflow-x: hidden;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 481px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 481px;
      animation: slide-in 0.5s forwards;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 100%;
      animation: slide-in-mobile 0.5s forwards;
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
        ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0px 0px;
      padding: 7px 0 45px 0px;
    }
    @keyframes slide-in {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0%);
      }
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }
    @keyframes slide-out {
      0% {
        transform: translateX(0%);
      }
      100% {
        transform: translateX(100%);
      }
    }

    .close-modal {
      right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      @media ${(props) => props.theme.mediaQuery.medium} {
        top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      }
    }
    .blurred-content {
      filter: blur(4px);
      -o-filter: blur(4px);
      -ms-filter: blur(4px);
      -moz-filter: blur(4px);
      -webkit-filter: blur(4px);
    }
    .Modal-Header {
      top: 0;
      position: sticky;
      z-index: 100;
      min-height: 51px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        top: -1px;
        min-height: 45px;
      }
    }
    .modal-heading {
      border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      justify-content: center;
      height: auto;
      display: block;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 17px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        justify-content: center;
        height: auto;
        padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        padding-top: 9px;
        text-align: center;
      }
    }
    .modal-heading.align-center {
      text-align: center;
    }
    .back-button {
      cursor: pointer;
      margin-top: 5px;
    }
    .modal-heading:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 51px;
      margin: auto;
      z-index: -1;
      background-color: #f4f4f4;
      bottom: 0;
      left: -17px;
      padding-right: 17px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        left: -17px;
        padding-right: 17px;
      }
    }
  }
  div.TCPModal__InnerContent.offer-details-innerContent.from-cart-offers {
    background: #fff;
    .modal-heading {
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding-right: 17px;
      }
    }
    .back-button {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: 4px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: auto;
      top: auto;
      max-height: 90vh;
    }
  }
`;
export default styles;
